(function () {
  var METAL_COLOR_PROPERTY = 'Metal Color';
  var RING_SIZE_PROPERTY = 'Ring Size (US)';
  var NECKLACE_SIZE_PROPERTY = 'Necklace Size';
  var METAL_COLORS = [
    { label: 'White Gold', key: 'white', src: '/cdn/shop/files/White_Gold.webp' },
    { label: 'Yellow Gold', key: 'yellow', src: '/cdn/shop/files/Yellow_Gold.webp' },
    { label: 'Rose Gold', key: 'rose', src: '/cdn/shop/files/Rose_Gold.webp' }
  ];
  var RING_SIZES = ['4', '4.5', '5', '5.5', '6', '6.5', '7', '7.5', '8', '8.5', '9', '9.5', '10', '10.5', '11', '11.5', '12', '12.5', '13'];
  var NECKLACE_SIZES = ['16" Delicate Collarbone Fit', '17" Just Below the Collarbone', '18" Timeless Classic Drop'];
  var retryTimer = null;

  function pageText() {
    return [
      window.location.pathname,
      document.querySelector('.t4s-product__title') ? document.querySelector('.t4s-product__title').textContent : '',
      document.querySelector('.t4s-breadcrumbs, .t4s-breadcrumb') ? document.querySelector('.t4s-breadcrumbs, .t4s-breadcrumb').textContent : ''
    ].join(' ').toLowerCase();
  }

  function isRingProductPage() {
    if (!document.body.classList.contains('template-product')) return false;
    var text = pageText();
    return /\bring\b|engagement-ring|wedding-ring|diamond-rings|engagement rings|wedding rings/.test(text);
  }

  function isNecklaceProductPage() {
    if (!document.body.classList.contains('template-product')) return false;
    var text = pageText();
    return /necklace|necklaces|pendant|tennis-necklace|tennis necklace|diamond-necklaces|diamond necklaces|solitaire necklace/.test(text);
  }

  function isLooseDiamondProductPage() {
    if (!document.body.classList.contains('template-product')) return false;
    var text = pageText();
    var jewelryWords = /ring|earring|necklace|bracelet|pendant|band|jewelry|eyewear|mount|setting/.test(text);
    if (jewelryWords) return false;
    return /loose|loose-diamond|lab-grown-diamond|lab diamond|igi diamond|diamond only/.test(text);
  }

  function shouldShowMetalColor() {
    return document.body.classList.contains('template-product') && !isLooseDiamondProductPage();
  }

  function findProductForm() {
    return document.querySelector('form[action*="/cart/add"], form[data-type="add-to-cart-form"], .t4s-form__product');
  }

  function ensurePropertyInput(form, propertyName, dataAttribute, defaultValue) {
    var hidden = form.querySelector('[' + dataAttribute + ']');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'properties[' + propertyName + ']';
      hidden.setAttribute(dataAttribute, '');
      form.appendChild(hidden);
    }
    if (!hidden.value) hidden.value = defaultValue;
    return hidden;
  }

  function getOptionBlockByLabel(pattern) {
    var candidates = document.querySelectorAll('.tpo_option-container, .tpo_option, .tpo_option-wrapper, .t4s-swatch__option, [data-swatch-option]');
    for (var i = 0; i < candidates.length; i += 1) {
      var text = (candidates[i].textContent || '').replace(/\s+/g, ' ').trim();
      if (pattern.test(text)) return candidates[i];
    }
    return null;
  }

  function applyCompactSelectStyle(select) {
    if (!select || select.getAttribute('data-lg-compact-styled') === 'true') return;
    select.setAttribute('data-lg-compact-styled', 'true');
    select.style.setProperty('-webkit-appearance', 'none', 'important');
    select.style.setProperty('-moz-appearance', 'none', 'important');
    select.style.setProperty('appearance', 'none', 'important');
    select.style.setProperty('display', 'block', 'important');
    select.style.setProperty('box-sizing', 'border-box', 'important');
    select.style.setProperty('width', '100%', 'important');
    select.style.setProperty('height', '46px', 'important');
    select.style.setProperty('min-height', '46px', 'important');
    select.style.setProperty('max-height', '46px', 'important');
    select.style.setProperty('padding', '0 40px 0 16px', 'important');
    select.style.setProperty('border', '1px solid #d9d9d9', 'important');
    select.style.setProperty('border-radius', '4px', 'important');
    select.style.setProperty('background-color', '#fff', 'important');
    select.style.setProperty('background-image', 'linear-gradient(45deg, transparent 50%, #8c8c8c 50%), linear-gradient(135deg, #8c8c8c 50%, transparent 50%)', 'important');
    select.style.setProperty('background-position', 'calc(100% - 21px) 50%, calc(100% - 15px) 50%', 'important');
    select.style.setProperty('background-repeat', 'no-repeat', 'important');
    select.style.setProperty('background-size', '6px 6px, 6px 6px', 'important');
    select.style.setProperty('color', 'var(--lg-heading-color, #1f1f1f)', 'important');
    select.style.setProperty('font-size', '14px', 'important');
    select.style.setProperty('font-weight', '400', 'important');
    select.style.setProperty('line-height', '46px', 'important');
    select.style.setProperty('box-shadow', 'none', 'important');
  }

  function setSelectedMetalColor(widget, value) {
    var form = findProductForm();
    var propertyInput = form ? ensurePropertyInput(form, METAL_COLOR_PROPERTY, 'data-lg-metal-color-property-input', 'White Gold') : null;
    widget.setAttribute('data-selected-metal-color', value);
    if (propertyInput) propertyInput.value = value;
    widget.querySelectorAll('[data-lg-metal-color-choice]').forEach(function (button) {
      var selected = button.getAttribute('data-value') === value;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  }

  function createMetalColorWidget() {
    var widget = document.createElement('div');
    widget.className = 'lg-metal-color-option';
    widget.setAttribute('data-lg-metal-color-option', '');
    var title = document.createElement('div');
    title.className = 'lg-metal-color-option__title';
    title.innerHTML = 'Select Metal Color <span>*</span>';
    widget.appendChild(title);
    var list = document.createElement('div');
    list.className = 'lg-metal-color-option__list';
    widget.appendChild(list);
    METAL_COLORS.forEach(function (color) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'lg-metal-color-option__choice';
      button.setAttribute('data-lg-metal-color-choice', '');
      button.setAttribute('data-value', color.label);
      button.setAttribute('aria-pressed', 'false');
      button.innerHTML = '<span class="lg-metal-color-option__image lg-metal-color-option__image--' + color.key + '"><img class="lg-metal-color-option__img" src="' + color.src + '" alt="' + color.label + '" loading="lazy"></span><span class="lg-metal-color-option__label">' + color.label + '</span>';
      button.addEventListener('click', function () { setSelectedMetalColor(widget, color.label); });
      list.appendChild(button);
    });
    setSelectedMetalColor(widget, 'White Gold');
    return widget;
  }

  function setSelectedRingSize(widget, value) {
    var form = findProductForm();
    var propertyInput = form ? ensurePropertyInput(form, RING_SIZE_PROPERTY, 'data-lg-ring-size-property-input', '4') : null;
    var select = widget.querySelector('[data-lg-ring-size-select]');
    widget.setAttribute('data-selected-ring-size', value);
    if (propertyInput) propertyInput.value = value;
    if (select && select.value !== value) select.value = value;
    applyCompactSelectStyle(select);
  }

  function createRingSizeWidget() {
    var widget = document.createElement('div');
    widget.className = 'lg-ring-size-option';
    widget.setAttribute('data-lg-ring-size-option', '');
    var label = document.createElement('label');
    label.className = 'lg-ring-size-option__title';
    label.setAttribute('for', 'lg-ring-size-select');
    label.textContent = 'Select Ring Size (US):';
    widget.appendChild(label);
    var select = document.createElement('select');
    select.id = 'lg-ring-size-select';
    select.className = 'lg-ring-size-option__select';
    select.setAttribute('data-lg-ring-size-select', '');
    RING_SIZES.forEach(function (size) {
      var option = document.createElement('option');
      option.value = size;
      option.textContent = size;
      select.appendChild(option);
    });
    select.addEventListener('change', function () { setSelectedRingSize(widget, select.value); });
    widget.appendChild(select);
    setSelectedRingSize(widget, '4');
    return widget;
  }

  function setSelectedNecklaceSize(widget, value) {
    var form = findProductForm();
    var propertyInput = form ? ensurePropertyInput(form, NECKLACE_SIZE_PROPERTY, 'data-lg-necklace-size-property-input', NECKLACE_SIZES[0]) : null;
    var select = widget.querySelector('[data-lg-necklace-size-select]');
    widget.setAttribute('data-selected-necklace-size', value);
    if (propertyInput) propertyInput.value = value;
    if (select && select.value !== value) select.value = value;
    applyCompactSelectStyle(select);
  }

  function createNecklaceSizeWidget() {
    var widget = document.createElement('div');
    widget.className = 'lg-necklace-size-option';
    widget.setAttribute('data-lg-necklace-size-option', '');
    var label = document.createElement('label');
    label.className = 'lg-necklace-size-option__title';
    label.setAttribute('for', 'lg-necklace-size-select');
    label.textContent = 'Select Necklace Size:';
    widget.appendChild(label);
    var select = document.createElement('select');
    select.id = 'lg-necklace-size-select';
    select.className = 'lg-necklace-size-option__select';
    select.setAttribute('data-lg-necklace-size-select', '');
    NECKLACE_SIZES.forEach(function (size) {
      var option = document.createElement('option');
      option.value = size;
      option.textContent = size;
      select.appendChild(option);
    });
    select.addEventListener('change', function () { setSelectedNecklaceSize(widget, select.value); });
    widget.appendChild(select);
    setSelectedNecklaceSize(widget, NECKLACE_SIZES[0]);
    return widget;
  }

  function insertBeforeIfNeeded(parent, element, beforeElement) {
    if (!parent || !element || !beforeElement) return false;
    if (element.parentNode === parent && element.nextElementSibling === beforeElement) return true;
    parent.insertBefore(element, beforeElement);
    return true;
  }

  function insertAfterIfNeeded(target, element) {
    if (!target || !element) return false;
    if (target.nextElementSibling === element) return true;
    target.insertAdjacentElement('afterend', element);
    return true;
  }

  function positionWidgets(metalWidget, ringWidget, necklaceWidget, form) {
    var stoneBlock = getOptionBlockByLabel(/select stone size|stone size/i);
    var metalBlock = getOptionBlockByLabel(/metal type/i);
    var buttons = form.querySelector('.t4s-product-form__buttons');

    if (metalWidget) {
      if (metalBlock && metalBlock.parentNode) {
        insertAfterIfNeeded(metalBlock, metalWidget);
      } else if (stoneBlock && stoneBlock.parentNode) {
        insertBeforeIfNeeded(stoneBlock.parentNode, metalWidget, stoneBlock);
      } else if (buttons && buttons.parentNode) {
        insertBeforeIfNeeded(buttons.parentNode, metalWidget, buttons);
      } else if (!metalWidget.parentNode) {
        form.appendChild(metalWidget);
      }
    }

    var lastWidget = metalWidget;
    if (ringWidget && lastWidget) {
      insertAfterIfNeeded(lastWidget, ringWidget);
      lastWidget = ringWidget;
    }
    if (necklaceWidget && lastWidget) {
      insertAfterIfNeeded(lastWidget, necklaceWidget);
    }
  }

  function iconSvg(type) {
    var icons = {
      cert: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l7 3v5c0 5-3.1 8.7-7 10-3.9-1.3-7-5-7-10V6l7-3z"/><path d="M8.5 12.2l2.1 2.1 4.8-5"/></svg>',
      craft: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l1.6 4.2L18 9l-4.4 1.8L12 15l-1.6-4.2L6 9l4.4-1.8L12 3z"/><path d="M18 15l.8 2.2L21 18l-2.2.8L18 21l-.8-2.2L15 18l2.2-.8L18 15z"/></svg>',
      ship: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h11v10H3z"/><path d="M14 10h4l3 4v3h-7z"/><circle cx="7" cy="18" r="1.8"/><circle cx="17" cy="18" r="1.8"/></svg>',
      resize: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 8a6 6 0 0 1 9.7-2"/><path d="M17 5v4h-4"/><path d="M16 16a6 6 0 0 1-9.7 2"/><path d="M7 19v-4h4"/></svg>'
    };
    return icons[type] || icons.cert;
  }

  function createProductGuarantees() {
    var wrap = document.createElement('div');
    wrap.className = 'lg-product-guarantees';
    wrap.setAttribute('data-lg-product-guarantees', '');
    var items = [
      ['cert', 'IGI Certified', 'Authentic & Verified'],
      ['craft', 'Made to Order', 'Crafted with Care'],
      ['ship', 'Free Shipping', 'Worldwide Delivery'],
      ['resize', 'Lifetime Resizing', 'For Eligible Rings']
    ];
    wrap.innerHTML = items.map(function (item) {
      return '<div class="lg-product-guarantee"><span class="lg-product-guarantee__icon">' + iconSvg(item[0]) + '</span><span class="lg-product-guarantee__text"><strong>' + item[1] + '</strong><em>' + item[2] + '</em></span></div>';
    }).join('');
    return wrap;
  }

  function findWhatsAppButton(form) {
    var scope = document.querySelector('.t4s-product__info-container') || form || document;
    var nodes = scope.querySelectorAll('a, button');
    for (var i = 0; i < nodes.length; i += 1) {
      var node = nodes[i];
      var text = (node.textContent || '').toLowerCase();
      var href = (node.getAttribute('href') || '').toLowerCase();
      var cls = (node.className || '').toString().toLowerCase();
      if (text.indexOf('whatsapp') !== -1 || href.indexOf('whatsapp') !== -1 || href.indexOf('wa.me') !== -1 || cls.indexOf('whatsapp') !== -1) return node;
    }
    return null;
  }

  function isDesktopProductLayout() {
    return window.matchMedia('(min-width: 768px)').matches;
  }

  function placeGuaranteesNearMedia(guarantee) {
    var mediaWrapper = document.querySelector('.template-product .t4s-product__media-wrapper');
    if (!mediaWrapper) return false;

    var mediaGroup = mediaWrapper.querySelector('[data-product-single-media-group]');
    if (mediaGroup) {
      mediaGroup.appendChild(guarantee);
    } else {
      mediaWrapper.appendChild(guarantee);
    }

    guarantee.classList.add('lg-product-guarantees--media');
    guarantee.classList.remove('lg-product-guarantees--info');
    guarantee.style.removeProperty('width');
    guarantee.style.removeProperty('max-width');
    return true;
  }

  function placeGuaranteesNearButtons(form, guarantee) {
    var whatsapp = findWhatsAppButton(form);
    var payment = document.querySelector('.template-product .shopify-payment-button');
    var buttons = form.querySelector('.t4s-product-form__buttons');

    guarantee.classList.add('lg-product-guarantees--info');
    guarantee.classList.remove('lg-product-guarantees--media');

    if (whatsapp && whatsapp.parentNode) {
      whatsapp.insertAdjacentElement('afterend', guarantee);
    } else if (payment && payment.parentNode) {
      payment.insertAdjacentElement('afterend', guarantee);
    } else if (buttons && buttons.parentNode) {
      buttons.insertAdjacentElement('afterend', guarantee);
    } else {
      form.appendChild(guarantee);
    }
  }

  function ensureProductGuarantees(form) {
    var guarantee = document.querySelector('[data-lg-product-guarantees]') || createProductGuarantees();
    if (isDesktopProductLayout() && placeGuaranteesNearMedia(guarantee)) return;
    placeGuaranteesNearButtons(form, guarantee);
  }

  function applyProductStyle() {
    if (document.getElementById('lg-product-button-style')) return;
    var style = document.createElement('style');
    style.id = 'lg-product-button-style';
    style.textContent = [
      '.template-product .t4s-product-form__buttons > .t4s-d-flex{display:flex!important;flex-wrap:nowrap!important;align-items:stretch!important;gap:12px!important}',
      '.template-product .t4s-product-form__qty,.template-product .t4s-quantity-wrapper{order:1!important;min-width:132px!important;width:132px!important;height:52px!important;min-height:52px!important;margin:0!important;box-sizing:border-box!important;border-radius:4px!important}',
      '.template-product .t4s-quantity-selector,.template-product .t4s-quantity-input{height:50px!important;min-height:50px!important;line-height:50px!important;font-size:15px!important}',
      '.template-product .t4s-quantity-wrapper button{height:52px!important;min-height:52px!important}',
      '.template-product .t4s-product-form__submit,.template-product button[name="add"]{order:2!important;flex:1 1 auto!important;width:auto!important;min-width:220px!important;height:52px!important;min-height:52px!important;margin:0!important;padding:0 32px!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;border-radius:4px!important;background:#1f1f1f!important;border:1px solid #1f1f1f!important;color:#fff!important;box-shadow:none!important;font-size:15px!important;font-weight:600!important;letter-spacing:.02em!important;text-transform:none!important}',
      '.template-product .t4s-product-form__submit:hover,.template-product button[name="add"]:hover{background:#000!important;border-color:#000!important;color:#fff!important}',
      '.template-product .t4s-product-form__submit *,.template-product button[name="add"] *{color:inherit!important;font:inherit!important}',
      '.template-product .t4s-pr-wishlist{order:3!important;min-width:52px!important;width:52px!important;height:52px!important;min-height:52px!important;line-height:52px!important;margin:0!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;border-radius:4px!important;box-sizing:border-box!important}',
      '.template-product .t4s-pr-wishlist .t4s-svg-pr-icon svg{width:20px!important;height:20px!important}',
      '.template-product .shopify-payment-button{margin-top:12px!important}.template-product .shopify-payment-button__button{min-height:52px!important;height:52px!important;padding:0 32px!important;border-radius:4px!important;font-size:15px!important;font-weight:600!important;letter-spacing:.02em!important}',
      '.lg-product-guarantees{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:10px 14px!important;margin:14px 0 0!important;padding:14px 0 0!important;border-top:1px solid #e8e2d8!important}',
      '.lg-product-guarantee{display:flex!important;align-items:center!important;gap:10px!important;min-height:44px!important;color:#1f1f1f!important}',
      '.lg-product-guarantee__icon{display:inline-flex!important;align-items:center!important;justify-content:center!important;flex:0 0 26px!important;width:26px!important;height:26px!important;border:1px solid #e8e2d8!important;border-radius:50%!important;background:#fbfaf7!important;color:#8a6a2f!important}',
      '.lg-product-guarantee__icon svg{width:15px!important;height:15px!important;fill:none!important;stroke:currentColor!important;stroke-width:1.8!important;stroke-linecap:round!important;stroke-linejoin:round!important}',
      '.lg-product-guarantee__text{display:flex!important;flex-direction:column!important;gap:1px!important;line-height:1.2!important}',
      '.lg-product-guarantee__text strong{font-size:13px!important;font-weight:600!important;color:#1f1f1f!important}',
      '.lg-product-guarantee__text em{font-style:normal!important;font-size:12px!important;font-weight:400!important;color:#746e66!important}',
      '@media(min-width:768px){.template-product .t4s-product__media-wrapper .lg-product-guarantees--media{display:grid!important;grid-template-columns:repeat(4,minmax(0,1fr))!important;gap:14px!important;width:100%!important;max-width:100%!important;margin:22px auto 0!important;padding:18px 20px!important;border:1px solid #eee7dc!important;border-radius:10px!important;background:#fffdf9!important;box-shadow:0 8px 24px rgba(0,0,0,.035)!important;box-sizing:border-box!important}.template-product .t4s-product__media-wrapper .lg-product-guarantees--media .lg-product-guarantee{justify-content:center!important;min-height:52px!important;padding:0 6px!important;text-align:left!important}.template-product .t4s-product__media-wrapper .lg-product-guarantees--media .lg-product-guarantee__icon{width:32px!important;height:32px!important;flex-basis:32px!important;background:#fbf7ef!important;border-color:#eadfce!important;color:#9a7438!important}.template-product .t4s-product__media-wrapper .lg-product-guarantees--media .lg-product-guarantee__icon svg{width:17px!important;height:17px!important}.template-product .t4s-product__media-wrapper .lg-product-guarantees--media .lg-product-guarantee__text strong{font-size:13px!important;font-weight:600!important;color:#1f1f1f!important}.template-product .t4s-product__media-wrapper .lg-product-guarantees--media .lg-product-guarantee__text em{font-size:12px!important;font-style:normal!important;color:#746e66!important}}',
      '.lg-metal-color-option{margin:12px 0!important}.lg-ring-size-option,.lg-necklace-size-option{margin:10px 0!important}',
      '.lg-metal-color-option__title,.lg-ring-size-option__title,.lg-necklace-size-option__title{display:block;margin:0 0 6px!important;color:#1f1f1f!important;font-size:16px!important;font-weight:400!important;line-height:1.4!important;letter-spacing:0!important;text-transform:none!important}',
      '.lg-metal-color-option__title span{color:#d71920!important}',
      '.lg-metal-color-option__list{display:flex;flex-wrap:wrap;gap:12px 18px!important}',
      '.lg-metal-color-option__choice{display:flex;flex-direction:column;align-items:center;gap:7px;padding:0;border:0;background:transparent;color:#1f1f1f;cursor:pointer;font:inherit;text-align:center}',
      '.lg-metal-color-option__image{position:relative;display:flex!important;align-items:center!important;justify-content:center!important;width:46px!important;height:46px!important;border:1px solid #d9d9d9!important;border-radius:6px!important;background:#fff!important;overflow:hidden!important;transition:border-color .18s ease,box-shadow .18s ease,transform .18s ease}',
      '.lg-metal-color-option__choice.is-selected .lg-metal-color-option__image{border-color:#202020!important;box-shadow:0 0 0 2px #fff,0 0 0 4px #202020!important;transform:translateY(-1px)!important}',
      '.lg-metal-color-option__choice.is-selected .lg-metal-color-option__image:after{content:"✓";position:absolute;right:3px;top:3px;width:18px;height:18px;border-radius:50%;background:#202020;color:#fff;font-size:12px;font-weight:700;line-height:18px;text-align:center;z-index:2}',
      '.lg-metal-color-option__img{display:block!important;width:100%!important;height:100%!important;object-fit:cover!important;border-radius:6px!important}',
      '.lg-metal-color-option__ring{display:none!important}',
      '.lg-metal-color-option__label{font-size:14px!important;line-height:1.25!important}',
      '.lg-metal-color-option__choice.is-selected .lg-metal-color-option__label{font-weight:600!important;color:#202020!important}',
      '.lg-ring-size-option__select,.lg-necklace-size-option__select{display:block!important;width:100%!important;height:46px!important;min-height:46px!important;max-height:46px!important;box-sizing:border-box!important}',
      '.template-product .t4s-product__info-container select:not([name="id"]),.template-product .tpo_option-set-wrapper select,.template-product .tpo_option-container select{height:46px!important;min-height:46px!important;max-height:46px!important;line-height:46px!important;padding-top:0!important;padding-bottom:0!important;box-sizing:border-box!important}',
      '@media(max-width:767px){.template-product .t4s-product-form__buttons>.t4s-d-flex{flex-wrap:wrap!important;gap:10px!important}.template-product .t4s-product-form__qty,.template-product .t4s-quantity-wrapper{width:100%!important;margin-right:0!important}.template-product .t4s-product-form__submit,.template-product button[name="add"]{flex:1 1 auto!important;min-width:0!important;margin-right:0!important}.lg-product-guarantees{grid-template-columns:1fr!important}.lg-metal-color-option__image{width:42px!important;height:42px!important}.lg-ring-size-option__select,.lg-necklace-size-option__select{height:46px!important;min-height:46px!important;max-height:46px!important}}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function initLuminaryGemCustom() {
    if (!document.body.classList.contains('template-product')) return;
    var form = findProductForm();
    if (!form) return;
    applyProductStyle();
    ensureProductGuarantees(form);

    var showMetal = shouldShowMetalColor();
    var showRing = isRingProductPage();
    var showNecklace = isNecklaceProductPage();
    if (!showMetal) return;

    var metalWidget = document.querySelector('[data-lg-metal-color-option]') || createMetalColorWidget();
    setSelectedMetalColor(metalWidget, ensurePropertyInput(form, METAL_COLOR_PROPERTY, 'data-lg-metal-color-property-input', 'White Gold').value || 'White Gold');

    var ringWidget = null;
    if (showRing) {
      ringWidget = document.querySelector('[data-lg-ring-size-option]') || createRingSizeWidget();
      setSelectedRingSize(ringWidget, ensurePropertyInput(form, RING_SIZE_PROPERTY, 'data-lg-ring-size-property-input', '4').value || '4');
    }

    var necklaceWidget = null;
    if (showNecklace) {
      necklaceWidget = document.querySelector('[data-lg-necklace-size-option]') || createNecklaceSizeWidget();
      setSelectedNecklaceSize(necklaceWidget, ensurePropertyInput(form, NECKLACE_SIZE_PROPERTY, 'data-lg-necklace-size-property-input', NECKLACE_SIZES[0]).value || '16" Delicate Collarbone Fit');
    }

    positionWidgets(metalWidget, ringWidget, necklaceWidget, form);
  }

  function scheduleInit() {
    var attempts = 0;
    if (retryTimer) clearInterval(retryTimer);
    initLuminaryGemCustom();
    retryTimer = setInterval(function () {
      attempts += 1;
      initLuminaryGemCustom();
      if (attempts >= 20) clearInterval(retryTimer);
    }, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleInit);
  else scheduleInit();
  document.addEventListener('shopify:section:load', scheduleInit);
  document.addEventListener('tpo_loaded', scheduleInit);
  document.addEventListener('easify:loaded', scheduleInit);
  window.addEventListener('resize', scheduleInit);
})();